import { combineReducers } from 'redux';
import {
  SET_SEARCH_TEXT_WIDTH,
  SET_SEARCH_VERTICAL_PADDING,
  SET_SEARCH_TEXT_BG_COLOR,
  SET_SEARCH_TEXT_COLOR,
  SET_SEARCH_BORDER_COLOR,
  SET_SEARCH_BUTTON_STYLE,
  SET_SEARCH_BUTTON_BG_COLOR,
  SET_SEARCH_BUTTON_TEXT_ICON_COLOR,
  SET_SEARCH_BUTTON_CONTENT,
  SET_SEARCH_ICON_COLOR,
  SET_SEARCH_PLACEHOLDER_TEXT,
} from '../actions/action-names';

const textWidth = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_TEXT_WIDTH:
      return action.value;
    default:
      return state;
  }
};

const verticalPadding = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_VERTICAL_PADDING:
      return action.value;
    default:
      return state;
  }
};

const textBgColor = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_TEXT_BG_COLOR:
      return action.value;
    default:
      return state;
  }
};

const textColor = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_TEXT_COLOR:
      return action.value;
    default:
      return state;
  }
};

const borderColor = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_BORDER_COLOR:
      return action.value;
    default:
      return state;
  }
};

const buttonStyle = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_BUTTON_STYLE:
      return action.value;
    default:
      return state;
  }
};

const buttonBgColor = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_BUTTON_BG_COLOR:
      return action.value;
    default:
      return state;
  }
};

const buttonTextIconColor = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_BUTTON_TEXT_ICON_COLOR:
      return action.value;
    default:
      return state;
  }
};

const buttonContent = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_BUTTON_CONTENT:
      return action.value;
    default:
      return state;
  }
};

const iconColor = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_ICON_COLOR:
      return action.value;
    default:
      return state;
  }
};

const placeholderText = (state = '', action) => {
  switch(action.type) {
    case SET_SEARCH_PLACEHOLDER_TEXT:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  textWidth,
  verticalPadding,
  textBgColor,
  textColor,
  borderColor,
  buttonStyle,
  buttonBgColor,
  buttonTextIconColor,
  buttonContent,
  iconColor,
  placeholderText,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/search-element-options-reducers.js